import { activeFilterCount } from "../utils/active-filter-count";
import { fetchFilteredResults } from "../utils/fetchFilteredResults";

export const feedSearch = ({
    formSelector,
    resultsContainerSelector,
    highlightedEntriesWrapperSelector,
}: {
    formSelector: string;
    resultsContainerSelector: string;
    highlightedEntriesWrapperSelector: string;
}) => {
    const searchForm = document.querySelector<HTMLFormElement>(formSelector);
    const resultsContainer = document.querySelector<HTMLElement>(
        resultsContainerSelector,
    );
    const highlightedEntriesWrapper = document.querySelector<HTMLElement>(
        highlightedEntriesWrapperSelector,
    );

    const filterHeading = searchForm
        ?.querySelector('[data-slot="filter-title"]')
        ?.querySelector("h3");

    let currentActive =
        searchForm?.querySelectorAll('input[type="checkbox"]:checked').length ??
        0;

    if (!searchForm || !resultsContainer) return;

    const submitForm = () => {
        const formData = new FormData(searchForm);
        const filtered = new URLSearchParams();
        currentActive = searchForm.querySelectorAll(
            'input[type="checkbox"]:checked',
        ).length;

        activeFilterCount({
            currentActive,
            filterHeading: filterHeading as HTMLElement,
        });

        for (const [key, value] of formData.entries()) {
            value
                ? highlightedEntriesWrapper?.setAttribute(
                      "data-visible",
                      "false",
                  )
                : highlightedEntriesWrapper?.setAttribute(
                      "data-visible",
                      "true",
                  );

            if (value) filtered.append(key, value.toString());
        }

        const url = new URL(searchForm.action, window.location.origin);
        url.search = filtered.toString();

        fetchFilteredResults(
            url.toString(),
            resultsContainer,
            resultsContainerSelector,
        );

        window.history.pushState({}, "", url.toString());
    };

    activeFilterCount({
        currentActive,
        filterHeading: filterHeading as HTMLElement,
    });

    searchForm.addEventListener("submit", (e) => {
        e.preventDefault();
        submitForm();
    });

    searchForm.addEventListener(
        "input",
        (() => {
            let timeoutId: ReturnType<typeof setTimeout>;
            return () => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    searchForm.requestSubmit();
                }, 300);
            };
        })(),
    );
};
